<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";

	export let value: string | number = '0'
	export let klass: string = ''
	export let focus : boolean = false
	export let isError: boolean = false
	export let disabled: boolean = false
	export let options = []
	let element
	let interval = null

	const dispatch = createEventDispatcher()

	function input(e: any) {
		dispatch('input', {
			value: e.target.value
		})
	}

	function keypress(e: any) {
		dispatch('keypress', {
			value: e.charCode
		})
	}

	onMount(() => {
		if (focus) {
			element.focus()
		}
	})
</script>

<select
	value={value}
	class="input-select {klass}"
	class:is-error={isError}
	on:input={input}
	on:keypress={keypress}
	bind:this={element}
	disabled={disabled}
>
	{#each options as o(o.id)}
		<option value={o.id}>
			{ o.label }
		</option>
	{/each}
</select>

<style lang="postcss">
	.input-select {
		@apply p-3 w-full text-sm bg-white;
	}
	.input-select:focus {
		@apply outline-none border-blue-400;
	}
	.is-error {
		@apply outline-none border-red-400;
	}
</style>